export function formatDistanceToNow(
	date: Date,
	opts?: { addSuffix?: boolean },
): string {
	const seconds = Math.round((Date.now() - date.getTime()) / 1000);
	const abs = Math.abs(seconds);
	const future = seconds < 0;

	const units: [number, string][] = [
		[60, "second"],
		[60, "minute"],
		[24, "hour"],
		[30, "day"],
		[12, "month"],
		[Number.POSITIVE_INFINITY, "year"],
	];

	let value = abs;
	let unit = "second";
	for (const [div, name] of units) {
		if (value < div) {
			unit = name;
			break;
		}
		value = Math.floor(value / div);
		unit = name;
	}

	const plural = value === 1 ? unit : `${unit}s`;
	const core = `${value} ${plural}`;
	if (!opts?.addSuffix) return core;
	return future ? `in ${core}` : `${core} ago`;
}

export function formatPPpp(date: Date): string {
	const datePart = date.toLocaleDateString(undefined, {
		month: "long",
		day: "numeric",
		year: "numeric",
	});
	const timePart = date.toLocaleTimeString(undefined, {
		hour: "numeric",
		minute: "2-digit",
		second: "2-digit",
		hour12: true,
	});
	return `${datePart} at ${timePart}`;
}
